import axios from 'axios';

export default {
  previewCustomerStatementNotification(customerId, params){
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/v1/admin/customers/"+customerId+"/statement/email", { params })
      .then(results=>{
        return results.data;
      })
  },
  delete (customerId) {
    return axios.delete(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/latest/admin/customers/" + customerId)
      .then(results=>{
        return results.data;
      })
  },
  fetchSearchedCustomers(params){
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/customers/", {params})
      .then(results=>{
        return results.data;
      })
  },
  fetchCustomers(params){
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/customers/", {params})
      .then(results=>{
        return results.data;
      })
  },
  fetchSearchedCustomersV2(params){
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/v1/admin/customers/", {params})
      .then(results=>{
        return results.data;
      })
  },
  fetchCustomersV2(params){
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/v1/admin/customers/", {params})
      .then(results=>{
        return results.data;
      })
  },
  getPublicCustomer (customerId) {
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/latest/customers/"+customerId)
    .then(results=>{
      return results.data;
    })
  },
  getCustomer(customerId){
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/customers/"+customerId)
      .then(results=>{
        return results.data;
      })
  },
  fetchCustomerContacts(customerId){
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/customers/"+customerId+"/contacts")
      .then(results=>{
        return results.data;
      })
  },
  createCustomer(postValue){
    return axios.post(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/customers",postValue)
      .then(response=>{
        return response.data;
      })
  },
  updateCustomer(putValue, customerId){
    return axios.put(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/customers/"+customerId,putValue)
      .then(response=>{
        return response.data;
      })
  },
  updateCustomerSettings(putValue, customerId){
    return axios.put(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/customers/"+customerId+"/settings",putValue)
      .then(response=>{
        return response.data;
      })
  },
  sendSimpleStatementNotification(id, contacts, content, language, attachment) {
    let data = {};
    data.contacts = contacts
    data.content = content;
    data.language=language;
    data.attachment=attachment;
    return axios.post(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/v1/admin/customers/"+id+"/statement/email", data)
      .then(results=>{
        return results.data;
      })
  },
  downloadCustomerExtraction(report,type, params) {
    params.reportType = type;
    params.report = report;
    let url = process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+`/API/latest/admin/customers/reports`;
    return axios({
          url: url,
          method: 'GET',
          params,
          responseType: 'blob', // important
        }).then((response) => {
           const url = window.URL.createObjectURL(new Blob(['\uFEFF', response.data], { type: 'text/csv; charset=utf-8' }));
           const link = document.createElement('a');
           link.href = url;
           link.setAttribute('download', 'customers.csv'); //or any other extension
           document.body.appendChild(link);
           link.click();
        });
  },
  downloadStatementReportV2(customerId, startDate, endDate, filename, type){
    let url = process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/latest/admin/customers/"+customerId+`/statement?type=${type}`;
    return axios({
          url: url,
          method: 'GET',
          responseType: 'blob', // important
        }).then((response) => {
           const url = window.URL.createObjectURL(new Blob([response.data]));
           const link = document.createElement('a');
           link.href = url;
           link.setAttribute('download', filename+'.pdf'); //or any other extension
           document.body.appendChild(link);
           link.click();
        });
  },
  downloadStatementReport(customerId, startDate, endDate, filename){
    let url = process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/customers/"+customerId+"/statement?startDate="+startDate+"&endDate="+endDate;
    return axios({
          url: url,
          method: 'GET',
          responseType: 'blob', // important
        }).then((response) => {
           const url = window.URL.createObjectURL(new Blob([response.data]));
           const link = document.createElement('a');
           link.href = url;
           link.setAttribute('download', filename+'.pdf'); //or any other extension
           document.body.appendChild(link);
           link.click();
        });
  },
  convertCustomer(customerId){
    return axios.put(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/latest/admin/customers/"+customerId+"/convert")
      .then(results=>{
        return results.data;
      })
  },

}
